import {useCallback, useEffect, useState} from "react";
import {IBouquet} from "../../../../entities/bouquets/api/types";
import { bouquetsListApi } from "../api/bouquets";

export const useBouquets = (page?: number, limit?: number)=> {
    const [bouquets, setBouquets] = useState<IBouquet[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const getBouquets  = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await bouquetsListApi.getBouquets();
            if (data && Array.isArray(data)) {
                setBouquets(data);
            }
        } catch (err: any) {
            setError(err?.message || 'Не удалось загрузить букеты');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        getBouquets()
    }, []);



    return {bouquets, loading, error, getBouquets };
}